"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantDashboardContract = void 0;
const contract_1 = require("../base/contract");
const dashboard_schemas_1 = require("../../schemas/merchant/dashboard.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
exports.MerchantDashboardContract = (0, contract_1.createContract)({
    name: 'MerchantDashboard',
    baseUrl: '/merchants',
    version: '1',
    serviceModule: 'merchant',
    endpoints: {
        getDashboard: {
            method: 'GET',
            path: '/:merchantId/dashboard',
            body: null,
            query: null,
            params: dashboard_schemas_1.getDashboardParamsSchema,
            headers: null,
            response: {
                success: dashboard_schemas_1.getDashboardResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:staff'],
            documentation: {
                summary: 'Get merchant dashboard overview',
                description: 'Retrieves dashboard overview with member count, active coupons, and today\'s stats.',
                tags: ['Merchant', 'Dashboard'],
                deprecated: false,
            },
            tests: [
                'should return dashboard overview for staff',
                'should include member count and active coupon count',
                'should include today redemptions and revenue',
            ],
        },
        // ============================================
        // V2 ENDPOINTS (uncomment when ready)
        // ============================================
        /*
        getDashboardStats: {
            method: 'GET',
            path: '/:merchantId/dashboard/stats',
            body: null,
            query: getDashboardStatsQuerySchema,
            params: getDashboardStatsParamsSchema,
            headers: null,
            response: {
                success: getDashboardStatsResponseSchema,
                errors: {
                    unauthorized: baseErrorResponseSchema,
                    forbidden: baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:staff'],
            documentation: {
                summary: 'Get merchant dashboard statistics',
                description: 'Retrieves detailed analytics including redemptions over time and top coupons.',
                tags: ['Merchant', 'Dashboard', 'Analytics'],
                deprecated: false,
            },
            tests: [
                'should return 7d stats when period=7d',
                'should return 30d stats by default',
                'should return 90d stats when period=90d',
                'should include redemptions over time',
                'should include top performing coupons',
            ],
        },
        */
    },
});
